import { USER_CALL_FETCH_REQUEST, USER_CALL_FETCH_SUCCESS, USER_CALL_FETCH_FAILURE } from './types';
import baseUrl from '../../url';

const fetchUserCallRequest = () => {
    return {
        type: USER_CALL_FETCH_REQUEST
    }
}

const fetchUserCallSuccess = user => {
    return {
        type: USER_CALL_FETCH_SUCCESS,
        payload: user,
    }
}

const fetchUserCallFailure = error => {
    return {
        type: USER_CALL_FETCH_FAILURE,
        payload: error,
    }
}

export const postCall = (phone) => {
    return (dispatch) => {
        dispatch(fetchUserCallRequest());
        fetch(`${baseUrl}/users/login/call`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    mobile: phone
                })
            })
            .then(response => response.json())
            .then((response) => {
                dispatch(fetchUserCallSuccess(response))
            })
            .catch((error) => {
                dispatch(fetchUserCallFailure(error.message));
            })
    }
}